import React, { Fragment, useContext, useState } from "react";
import { FaHospitalSymbol, FaBell } from "react-icons/fa";
import { IoMdAlert } from "react-icons/io";
import { PageNavigation, PatientInfoTable } from "..";
import { PatientStratificationInfo } from "../PatientStratification/PatientStratificationInfo";
import {
  NumberFieldFilter,
  SelectFieldFilter,
  TextFieldFilter,
} from "./TableFilter";
import { useAuth } from "../../contexts/AuthContext";
import { StratificationTableContext } from "./PatientHospitalPresentStratificationTable";

export const PatientHospitalPresentStratificationTableBody = ({
  id,
  ...props
}) => {
  const { getTableBodyProps, rows, prepareRow, visibleColumns } = useContext(
    StratificationTableContext,
  );
  const [navigation, setNavigation] = useState("riskFactors");
  const { checkLicense } = useAuth();

  const getRowProps = (row) => {
    if (row.original.status === "noCheckin") {
      return { style: { background: "#454552", color: "#ffffff" } };
    } else if (row.original.require_attention) {
      return { style: { background: "#0164A7", color: "#ffffff" } };
    } else if (row.original.status === "none") {
      return { style: { background: "#0164A7", color: "#ffffff" } };
    } else if (row.original.status === "riskLevelOne") {
      return { style: { background: "#279112", color: "#ffffff" } };
    } else if (row.original.status === "riskLevelTwo") {
      return { style: { background: "#ECA100", color: "#ffffff" } };
    } else if (row.original.status === "riskLevelThree") {
      return { style: { background: "#A63A49", color: "#ffffff" } };
    }
  };

  return (
    <tbody {...getTableBodyProps()}>
      <tr role="row" className="stratification-filter-row">
        <td></td>
        <TextFieldFilter
          onChange={props.handleFilterChange}
          onSubmit={props.onSubmit}
          filter={props.filter}
          field="external_id"
        />
        <TextFieldFilter
          onChange={props.handleFilterChange}
          onSubmit={props.onSubmit}
          filter={props.filter}
          field="name"
        />
        <NumberFieldFilter
          onChange={props.handleFilterChange}
          onSubmit={props.onSubmit}
          filter={props.filter}
          field="risk_drugs_count"
        />
        <NumberFieldFilter
          onChange={props.handleFilterChange}
          onSubmit={props.onSubmit}
          filter={props.filter}
          field="risk_diagnoses_count"
        />
        <NumberFieldFilter
          onChange={props.handleFilterChange}
          onSubmit={props.onSubmit}
          filter={props.filter}
          field="lab_results_count"
        />
        <SelectFieldFilter
          onChange={props.handleFilterChange}
          filter={props.filter}
          options={[
            { id: 0, name: "Vyberte", value: undefined },
            { id: 1, name: "ANO", value: true },
            { id: 2, name: "NE", value: false },
          ]}
          field="polypharmacy"
          onSubmit={props.onSubmit}
        />
        <NumberFieldFilter
          onChange={props.handleFilterChange}
          onSubmit={props.onSubmit}
          filter={props.filter}
          field="keywords_count"
        />
        <td>
          <button className="button" onClick={props.handleResetFilter}>
            Resetovat filtr
          </button>
        </td>
      </tr>

      {rows.map((row) => {
        prepareRow(row);
        return (
          <Fragment key={row.index}>
            <tr {...row.getRowProps(getRowProps(row))}>
              <td>
                {row.original.requisitions?.length !== 0 && (
                  <IoMdAlert
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Žádanka"
                    style={
                      row.original.requisitions?.some(
                        (item) => item.state === "pending",
                      )
                        ? { color: "#A63A49", fontSize: 20 }
                        : { color: "#b0b0b6", fontSize: 20 }
                    }
                  />
                )}
                {row.original.planned_hospitalization && (
                  <FaHospitalSymbol
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Plánovaná hospitalizace"
                    style={{ color: "#b0b0b6", fontSize: 17, marginLeft: 4 }}
                  />
                )}
                {checkLicense("penfast") &&
                  row.original.current_care.current_penfast && (
                    <FaBell
                      data-toggle="tooltip"
                      data-placement="top"
                      title={
                        row.original.penfastStatus === "red"
                          ? "Nový PEN-FAST"
                          : row.original.penfastStatus === "green"
                            ? "Zhodnocen klinickým farmaceutem + challenge"
                            : row.original.penfastStatus === "white"
                              ? "Zhodnocen klinickým farmaceutem"
                              : ""
                      }
                      style={
                        row.original.penfastStatus === "red"
                          ? { color: "#a63a49", fontSize: 17, marginLeft: 4 }
                          : row.original.penfastStatus === "green"
                            ? { color: "#279112", fontSize: 17, marginLeft: 4 }
                            : row.original.penfastStatus === "white"
                              ? {
                                  color: "#eca100",
                                  fontSize: 17,
                                  marginLeft: 4,
                                }
                              : {}
                      }
                    />
                  )}
              </td>
              {row.cells.map((cell) => (
                <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
              ))}
            </tr>

            {row.isExpanded ? (
              <tr role="row" className="stratification-expanded-row">
                <td colSpan={visibleColumns.length}>
                  <div className="stratification-expanded-wrap">
                    <PageNavigation className="sub-page-navigation present">
                      <div>
                        <a
                          className={
                            navigation === "riskFactors" ? "active" : ""
                          }
                          onClick={() => setNavigation("riskFactors")}
                        >
                          Rizikové faktory
                        </a>
                      </div>
                      <div>
                        <a
                          className={navigation === "info" ? "active" : ""}
                          onClick={() => setNavigation("info")}
                        >
                          Informace o pacientovi
                        </a>
                      </div>
                    </PageNavigation>

                    {navigation === "info" && (
                      <PatientInfoTable
                        id={row.original.id}
                        row={row}
                        careType={row.original.current_care.care_type}
                      />
                    )}
                    {navigation === "riskFactors" && (
                      <PatientStratificationInfo
                        careId={row.original.current_care.id}
                        patientName={row.original.name}
                        onBack={() => row.toggleRowExpanded()}
                      />
                    )}
                  </div>
                </td>
              </tr>
            ) : null}
          </Fragment>
        );
      })}
    </tbody>
  );
};
